import { ReactNode } from "react"

export function NavigationButton({
  children,
  handleOnClick,
  disabled,
  ...rest
}: {
  children?: ReactNode
  handleOnClick?: () => void
  disabled?: boolean
}) {
  return (
    <button
      onClick={handleOnClick}
      disabled={disabled}
      className={`${disabled ? "cursor-default text-gray-300" : "text-gray-700"} flex flex-row items-center gap-2 rounded-lg border bg-white px-4 py-1 font-semibold`}
      {...rest}
    >
      {children}
    </button>
  )
}

export function NumberButton({
  currentPage,
  value,
  onClick,
  ...rest
}: {
  currentPage: number
  value: number | string
  onClick?: () => void
}) {
  return (
    <button
      onClick={onClick}
      className={`${currentPage === value ? "bg-gray-300 text-gray-800" : ""} h-8 w-8 rounded-lg font-semibold text-gray-700 hover:bg-gray-300`}
      {...rest}
    >
      {value}
    </button>
  )
}

export function PageNumberButtons({
  currentPage,
  totalNumberOfPages,
  handleOnClick,
}: {
  currentPage: number
  totalNumberOfPages: number
  handleOnClick: (idx: number) => void
}) {
  return Array.from({ length: totalNumberOfPages }, (_, idx) => (
    <NumberButton
      onClick={() => handleOnClick(idx)}
      currentPage={currentPage}
      value={idx + 1}
      key={idx}
    />
  ))
}
